<template>
  <mt-popup v-model="popupVisible" position="bottom" style="width: 10.01rem;">
    <div class="popup-content">
      <div class="popup-header">
        <span @click="popupVisible=false">
          <svg-icon icon-class="close" class-name="btn-close"></svg-icon>
        </span>
      </div>
      <div class="popup-list">
        <template v-if="list.length">
          <div class="list-item" v-for="(item, index) in list" :key="index" @click="handleClick(item)">
            <img :src="item.adImg" alt="">
            <div class="item-info">
              <h3>{{ item.adTitle }}</h3>
              <mt-button type="danger">去购买</mt-button>
            </div>
          </div>
        </template>
        <div v-else class="popup-empty">暂无商品</div>
      </div>
    </div>
  </mt-popup>
</template>

<script>
import { Popup, Button } from 'mint-ui';

export default {
  components: {
    [Popup.name]: Popup,
    [Button.name]: Button,
  },

  props: {
    visible: {
      type: Boolean,
      default: false
    },

    list: {
      type: Array,
      default: () => ([])
    }
  },

  data() {
    return {
      popupVisible: false
    }
  },

  watch: {
    visible(val) {
      if (val) {
        this.popupVisible = this.visible
      }
    },

    popupVisible(val) {
      if (!val) {
        this.$emit('update:visible', false)
      }
    }
  },

  methods: {
    handleClick(item) {
      window.open(item.adUrl)
    }
  }
}
</script>

<style lang="scss" scoped>

.popup-content {
  min-height: 50vh;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  overflow: auto;

  .popup-header {
    padding: 20px 20px 20px 0;
    text-align: right;
    color: #ccc;
    box-sizing: border-box;

    .btn-close {
      cursor: pointer;
    }
  }

  .popup-list {
    flex: 1;
    overflow: auto;

    .list-item {
      display: flex;
      padding: 15px 20px;
      color: #333;
      box-sizing: border-box;

      &:hover {
        background: #efefef;
      }
  
      img {
        width: 200px;
        margin-right: 20px;
        border-radius: 8px;
        object-fit: contain;
      }
  
      .item-info {
        flex: 1;
        position: relative;

        h3 {
          font-size: 28px;
        }

        .mint-button {
          position: absolute;
          bottom: 10px;
          right: 20px;
        }
      }
    }

    .popup-empty {
      margin-top: 180px;
      color: #bbb;
      font-size: 36px;
      text-align: center;
    }
  }

}
</style>